import { Outlet, Navigate } from "react-router-dom";

export const PrivateRoute = () => {
    let auth = {'pass': localStorage.getItem('access')}
    return(
        auth?.pass?.length > 0 ? <Outlet/> : <Navigate to="/"/>
    )
}